import { gql, useQuery } from "@apollo/client";

export const useNetworkStatus = (polling = true) => {

  const { data, error, loading } = useQuery(
    gql`
      query networkStatus {
        networkStatus {
          id
          __typename
          available
          statusColor
          statusIcon
          statusMessage
          statusMessageHome
          statusMessageOrder
          pricingTiers {
            id
            name
            description
            amount
            amount_per
            available
            statusColor
            statusIcon
            statusMessage
            statusMessageHome
            statusMessageOrder
            __typename
          }
          availableDoctors {
            id
            doctorImage
            name
            __typename
          }
        }
      }
    `,
      {
        fetchPolicy: 'cache-first'
      }
  );

  const resolvePricingTier= (serviceID, clinicID) => {
    let pricingTierID = "plantmedinitial";
    if (serviceID === "plantmedconsult") {
      pricingTierID =
        clinicID === "telehealthnurse"
          ? "plantconsultationnurse"
          : "plantconsultation";
    }
    if (serviceID === "plantmedconsultfollowup") {
      pricingTierID =
        clinicID === "telehealthnurse"
          ? "plantconsultationfollowupnurse"
          : "plantconsultationfollowup";
    }

    return data?.networkStatus?.pricingTiers?.find(x => x.id === pricingTierID);
  };

  return {
    override: false,
    statusError: error,
    statusLoading: loading,
    statusColor: data?.networkStatus?.statusColor,
    statusIcon: data?.networkStatus?.statusIcon,
    statusAvailable: data?.networkStatus?.available,
    statusMessage: data?.networkStatus?.statusMessage,
    statusMessageHome: data?.networkStatus?.statusMessageHome,
    statusMessageOrder: data?.networkStatus?.statusMessageOrder,
    pricingTiers: data?.networkStatus?.pricingTiers || [],
    availableDoctors: data?.networkStatus?.availableDoctors || [],
    resolvePricingTier,
  };
};

